import { useTranslation } from 'react-i18next';
import { formatDateTime, formatInteger } from '../common/formatHelper';
import { ColumnConfig } from '../components/DatasetTable';
import CopyToClipboardButton from '../components/actions/CopyToClipboardButton';
import Tag from '../helpContext/Tag';
import EmptyValueTag from '../simulation/tags/EmptyValueTag';
import { getProcessingPipelineTypeDetailById, useProcessingPipelineTypeDetails } from './hooks/useProcessingPipelineTypeDetails';
import { ProcessingPipelinesTableRow } from './store/processingPipelineJobs.types';

function useProcessingPipelinesTableConfig(): ColumnConfig<ProcessingPipelinesTableRow>[] {
  const { t } = useTranslation('app');
  const pipelineTypeDetails = useProcessingPipelineTypeDetails();

  const config: ColumnConfig<ProcessingPipelinesTableRow>[] = [
    {
      field: 'enabled',
      title: t`Status`,
      render: (v, row) => {
        return (
          <Tag classType={v ? 'bg-alerts-okay' : ''}>
            {v ? t`Enabled` : t`Disabled`}
          </Tag>
        );
      },
    },
    {
      field: 'pipelineType',
      title: t`Type`,
      render: (v, row) => {
          
        const typeDetail = getProcessingPipelineTypeDetailById(pipelineTypeDetails, v);
        return <Tag>{typeDetail?.title ?? v}</Tag>;
      },
    },
    {
      field: 'createdAt',
      title: t`Date`,
      render: (v, row) => {
        const createdAt = new Date(row.createdAt);
        const updatedAt = new Date(row.updatedAt);
        const showUpdated = createdAt.getTime() !== updatedAt.getTime();

        return (
          <div className="space-y-1">
            <div className="text-xs" title={t`Created at`}>
              {formatDateTime(new Date(row.createdAt))}
            </div>
            {showUpdated && (
              <div className="text-xs" title={t`Updated at`}>
                {formatDateTime(new Date(row.updatedAt))}
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: 'title',
      title: t`Title`,
    },
    {
      field: 'description',
      title: t`Description`,
    },
    {
      field: 'jobs.totalCount',
      title: t`Jobs`,
      render: value => {
        if (value === null || value === 0 || isNaN(value)) {
          return <EmptyValueTag />;
        } else {
          return <div className="">{formatInteger(value)}</div>;
        }
      },
    },
    {
      field: 'id',
      title: t`ID`,
      render: (v: string) => (
        <CopyToClipboardButton truncate title={v} value={v} />
      ),
    },
  ];

  return config;
}

export default useProcessingPipelinesTableConfig;
